import GallerySettingsModal from './components/GallerySettingsModal';
const Modals = {
    GALLERY_SETTINGS: 'gallery-settings'
};
const ModalsMap = {
    [Modals.GALLERY_SETTINGS]: GallerySettingsModal
};
export { Modals, ModalsMap };

//# sourceMappingURL=modals.js.map